
import React, { useState, useEffect } from 'react';
import { PrivacyConsent } from "../register/components/PrivacyConsent";
import ForgetPassword from "../pages/auth/ForgetPassword";
import { useTranslation } from "react-i18next";


const ForgetPasswordModal = ({ onClose, openLoginModal, setIsForgotModalOpen }) => {
const { t } = useTranslation();
  return (
    <div className="">
      <div className="">
        <ForgetPassword
          setIsForgotModalOpen={setIsForgotModalOpen}
          openLoginModal={openLoginModal}
        />
        <div className="backto-wrapper">
          <div className="backto-text">{t(`forgotPassword.backTo`)}</div>
          <div className="backto-link">
            <div
              className="text--white"
              style={{ cursor: "pointer", fontWeight: 900 }}
              onClick={openLoginModal}
            >
              {t(`forgotPassword.signIn`)}
            </div>
          </div>

        </div>

      </div>
    </div>
  );
};


export default ForgetPasswordModal;
